const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Skip tracking during react-snap pre-render so build crawls don't pollute data.
const isPrerender = () =>
  typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent || '');

export const trackEvent = (type, path) => {
  if (isPrerender() || !BACKEND_URL) return;
  try {
    fetch(`${BACKEND_URL}/api/analytics/collect`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type,
        path: path || (typeof window !== 'undefined' ? window.location.pathname : '/'),
        referrer: typeof document !== 'undefined' ? document.referrer || '' : '',
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* analytics must never break the app */
  }
};

export const trackPageview = (path) => trackEvent('pageview', path);
export const trackDownload = (path) => trackEvent('download', path);
